import { PlateRenderElementProps } from 'lib-knowledge-document-structure/plate/common';

import s from './elements/elements.module.scss';

export const BoldMark = ({
  attributes,
  children,
}: PlateRenderElementProps): JSX.Element => (
  <strong {...attributes} className={s.bold}>
    {children}
  </strong>
);

export const ItalicMark = ({
  attributes,
  children,
}: PlateRenderElementProps): JSX.Element => (
  <em {...attributes} className={s.italic}>
    {children}
  </em>
);

export const UnderlineMark = ({
  attributes,
  children,
}: PlateRenderElementProps): JSX.Element => (
  <u {...attributes} className={s.underline}>
    {children}
  </u>
);

export const StrikethroughMark = ({
  attributes,
  children,
}: PlateRenderElementProps): JSX.Element => (
  <s {...attributes} className={s.strikethrough}>
    {children}
  </s>
);

export const CodeMark = ({
  attributes,
  children,
}: PlateRenderElementProps): JSX.Element => (
  <code {...attributes} className={s.code}>
    {children}
  </code>
);
